import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { updateUserNameClientSchema } from '../shared/validations/userValidations';
import translations from './ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { InfoIsFromEmployerMessage } from './common/CommonComponents.js';
import { getInfoForUser } from './common/util.js';

const NameForm = ({ onFinish }) => {
  const { lang } = useLanguage(translations);
  const { user, userEmployments, api } = useAuth();
  const { name, infoComesFromEmployer } = getInfoForUser(
    user,
    userEmployments,
    (v) => v.name?.givenName && v.name?.familyName,
  );

  return (
    <ValidatedForm
      key="userName"
      schema={updateUserNameClientSchema}
      initialValues={{ name }}
      preValidation={({ clearValueIfEmptyString }) => {
        clearValueIfEmptyString('name.middleName');
      }}
      handleSubmit={api.updateUserName}
      onFinish={onFinish}
    >
      {infoComesFromEmployer && <InfoIsFromEmployerMessage />}
      <FormInput name="name.givenName" type="text" />
      <FormInput name="name.middleName" type="text" />
      <FormInput name="name.familyName" type="text" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default NameForm;
